import { render, staticRenderFns } from "./Staffs.vue?vue&type=template&id=c21c548c&scoped=true&"
import script from "./Staffs.vue?vue&type=script&lang=js&"
export * from "./Staffs.vue?vue&type=script&lang=js&"
import style0 from "./Staffs.vue?vue&type=style&index=0&id=c21c548c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21c548c",
  null
  
)

export default component.exports